export default __webpack_public_path__ + "static/media/man.54f2ee25.png";